import React from "react";
import { Link } from "react-router-dom";
import { Home, Phone, MessageCircle, Compass } from "lucide-react";
import { BRAND, telHref, waHref } from "../lib/site";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-orange-50 p-6"
    >
      <div className="max-w-lg w-full text-center">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-700 to-orange-500 text-white grid place-items-center mx-auto shadow-lg">
          <Compass size={30} />
        </div>
        <h1 className="mt-6 text-5xl font-extrabold text-slate-900 tracking-tight" style={{ fontFamily: "Outfit" }}>
          404
        </h1>
        <p className="mt-2 text-lg font-semibold text-slate-700">
          Yeh page nahi mila
        </p>
        <p className="mt-2 text-sm text-slate-500">
          Jo page aap dhoondh rahe hain woh exist nahi karta. Hamare homepage par wapas jaayein ya hum se baat kijiye.
        </p>

        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="notfound-home-btn"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-blue-800 hover:bg-blue-900 text-white text-sm font-semibold shadow"
          >
            <Home size={16} /> Go to Homepage
          </Link>
          <a
            href={telHref}
            data-testid="notfound-call-btn"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-orange-600 hover:bg-orange-700 text-white text-sm font-semibold shadow"
          >
            <Phone size={16} /> Call {BRAND.phone}
          </a>
          <a
            href={waHref()}
            target="_blank"
            rel="noreferrer"
            data-testid="notfound-whatsapp-btn"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white text-sm font-semibold shadow"
          >
            <MessageCircle size={16} /> WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}
